import SelectCollection       from '@widesk-ui/components/form/SelectCollection';
import createSelect           from '@widesk-ui/tools/createSelect';
import StonecodeFileTypeModel from '@models/file/StonecodeFileTypeModel';

const Select = createSelect<typeof StonecodeFileTypeModel>(props => (
	<SelectCollection
		modelClass={StonecodeFileTypeModel}
		renderOption={m => m.renderName()}
		sortName="label"
		sortWay="asc"

		{...props}
	/>
));

export default Select;